export const getBaseUrlDomainForPlausible = () => {
  const clientUrl = process.env.NEXT_PUBLIC_CLIENT_URL;

  if (!clientUrl) {
    return "ecologi.com";
  }

  return new URL(clientUrl).hostname;
};
